.ResizeHandle {
  flex: 0 0 0.25rem;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  outline: none;
  transition: background-color 0.2s linear;
}
.ResizeHandle[data-resize-handle-active="keyboard"],
.ResizeHandle[data-resize-handle-active="pointer"] {
  background-color: var(--color-resize-bar-drag);
}

@media (pointer: coarse) {
  .ResizeHandle {
    flex: 0 0 1rem;
  }
}
